const formatItemsSentence = (items) => {
  if (items.length <= 1) {
    return items.toString();
  }

  const dupItems = [...items];
  const lastItem = dupItems.pop();

  return `${dupItems.join(', ')} and ${lastItem}`;
};

export default formatItemsSentence;
